"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _breakpoints = _interopRequireDefault(require("../../constants/breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\tborder-radius: 9999px;\n\tborder: 4px solid white;\n\tbox-shadow: 0px 2px 8px hsla(0, 0%, 0%, 0.25);\n\twidth: 100%;\n\theight: 100%;\n\tbackground: white;\n\n\t& > svg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t}\n\n\t@media (min-width: ", ") {\n\t\t.svg-item {\n\t\t\twidth: 80%;\n\t\t}\n\t}\n\n\t.donut-ring {\n\t\tstroke: ", ";\n\t\tfill: transparent;\n\t\tstroke-width: 5;\n\t}\n\n\t.donut-hole {\n\t\tfill: white;\n\t}\n\n\t.donut-segment {\n\t\ttransform-origin: center;\n\t\tstroke-dashoffset: 25;\n\t\tanimation: donut2 2s forwards;\n\t\tfill: transparent;\n\t\tstroke-width: 5;\n\t}\n\n\t@keyframes donut2 {\n\t\t0% {\n\t\t\tstroke-dasharray: 100, 0;\n\t\t}\n\t\t30% {\n\t\t\tstroke-dasharray: 100, 0;\n\t\t}\n\t\t100% {\n\t\t\tstroke-dasharray: ", ",\n\t\t\t\t", ";\n\t\t}\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Item = _styledComponents.default.div(_templateObject(), _breakpoints.default.smallDesktop, _colors.default.primaryLight, function (props) {
  return 100 - props.percent;
}, function (props) {
  return props.percent;
});

Item.displayName = 'Item';

var Donut = function Donut(_ref) {
  var children = _ref.children,
      percents = _ref.percents,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "percents"]);

  return _react.default.createElement(Item, _extends({
    percent: percents
  }, props), percents.length !== 0 && _react.default.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 38 38",
    className: "donut"
  }, _react.default.createElement("circle", {
    className: "donut-hole",
    cx: "19",
    cy: "19",
    r: "15.91549430918954"
  }), _react.default.createElement("circle", {
    className: "donut-ring",
    cx: "19",
    cy: "19",
    r: "15.91549430918954"
  }), percents.reduce(function (_ref2, _ref3) {
    var parts = _ref2.parts,
        percentUsed = _ref2.percentUsed;
    var percent = _ref3.percent,
        color = _ref3.color;
    return {
      parts: [].concat(parts, [_react.default.createElement("circle", {
        key: percent + " " + color + " " + percentUsed,
        className: "donut-segment",
        "data-testid": "donut-segment",
        cx: "19",
        cy: "19",
        r: "15.91549430918954",
        strokeDasharray: percent + percentUsed + ", " + (100 - (percent + percentUsed)),
        strokeDashoffset: "25",
        stroke: color
      })]),
      percentUsed: percentUsed + percent
    };
  }, {
    parts: [],
    percentUsed: 0
  }).parts.reverse()), children);
};

Donut.propTypes = {
  percents: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    percent: _propTypes.number.isRequired,
    color: _propTypes.string.isRequired
  })),
  children: _propTypes.node
};
Donut.defaultProps = {
  percents: [],
  children: null
};
var _default = Donut;
exports.default = _default;